<mat-card class="card-choose">
  @if (data?.showClose) {
    <button
      mat-icon-button
      class="dialog-close"
      aria-label="Fechar"
      mat-dialog-close
    >
      <mat-icon>close</mat-icon>
    </button>
  }

  <div class="dialog-body">
    @if (data?.icon) {
      <mat-icon class="dialog-icon">{{ data.icon }}</mat-icon>
    }
    <p class="dialog-message">
      {{ data?.message ?? data }}
    </p>
  </div>

  @if (data?.copyText) {
    <button
      mat-stroked-button
      type="button"
      class="dialog-copy"
      (click)="copyMessage()"
    >
      <mat-icon>content_copy</mat-icon>
      Copiar mensagem
    </button>
  }

  <div class="dialog-actions">
    <button
      mat-stroked-button
      class="dialog-btn-secondary"
      [mat-dialog-close]="false"
    >
      Não
    </button>
    <button mat-flat-button class="btn-tg dialog-btn" [mat-dialog-close]="true">
      Sim
    </button>
  </div>
</mat-card>
